<script>
  import propsBinder from 'vue2-leaflet/src/utils/propsBinder.js'
  import findRealParent from 'vue2-leaflet/src/utils/findRealParent.js'
  import {
    optionsMerger
  } from 'vue2-leaflet/src/utils/optionsUtils.js'
  import L from 'leaflet'
  import LayerGroup from 'vue2-leaflet/src/mixins/LayerGroup.js'
  import _ from 'lodash'

function simpleidw (canvas, map) {
    if (!(this instanceof simpleidw)) {
      return new simpleidw(canvas, map)
    }

    this._map = map;

    this._canvas = canvas = typeof canvas === 'string' ? document.getElementById(canvas) : canvas

    this._ctx = canvas.getContext('2d')
    this._width = canvas.width
    this._height = canvas.height

    this._max = 30
    this._data = []
}

simpleidw.prototype = {

  defaultCellSize: 0.25,

  defaultGradient: {
    0.0: '#000066',
    0.1: 'blue',
    0.2: 'cyan',
    0.3: 'lime',
    0.4: 'yellow',
    0.5: 'orange',
    0.6: 'red',
    0.7: 'Maroon',
    0.8: '#660066',
    0.9: '#990099',
    1.0: '#ff66ff'
  },
  data: function (data) {
    this._data = data
    return this
  },

  max: function (max) {
    this._max = max
    return this
  },

  add: function (point) {
    this._data.push(point)
    return this
  },

  clear: function () {
    this._data = []
    return this
  },

  cellSize: function (r, p) {
    //Get block distance on maps
    let a, b
    if (!p) {
      a = this._map.latLngToContainerPoint([0, 0])
      b = this._map.latLngToContainerPoint([0 + r, 0 + r])
    } else {
      let current = this._map.containerPointToLatLng([p[0], p[1]])
      a = this._map.latLngToContainerPoint([current.lat - (r / 2), current.lng - (r / 2)])
      b = this._map.latLngToContainerPoint([current.lat + (r / 2), current.lng + (r / 2)])
    }
    let cellwidth = Math.abs(a.x - b.x)
    let cellheight = Math.abs(a.y - b.y)
    // create a grayscale blurred cell image that we'll use for drawing points
    var cell = this._cell = document.createElement("canvas"),
      ctx = cell.getContext('2d')
    this._r = r

    cell.width = cellwidth
    cell.height = cellheight

    ctx.beginPath()
    ctx.rect(0, 0, cellwidth, cellheight)
    ctx.fill()
    ctx.closePath()

    return this
  },

  resize: function () {
    this._width = this._canvas.width
    this._height = this._canvas.height
  },

  gradient: function (grad) {
    // create a 256x1 gradient that we'll use to turn a grayscale heatmap into a colored one
    var canvas = document.createElement("canvas"),
      ctx = canvas.getContext('2d'),
      gradient = ctx.createLinearGradient(0, 0, 0, 256)

    canvas.width = 1
    canvas.height = 256

    for (var i in grad) {
      gradient.addColorStop(+i, grad[i])
    }

    ctx.fillStyle = gradient
    ctx.fillRect(0, 0, 1, 256)

    this._grad = ctx.getImageData(0, 0, 1, 256).data

    return this
  },

  draw: function (opacity) {
    if (!this._grad) this.gradient(this.defaultGradient)

    var ctx = this._ctx
    ctx.clearRect(0, 0, this._width, this._height)
    // draw a grayscale idwmap by putting a cell at each data point
    for (var i = 0, len = this._data.length, p; i < len; i++) {
      p = this._data[i]
      if (i % 200 == 0) {
        this.cellSize(this.defaultCellSize, p)
      }
      ctx.globalAlpha = p[2] / this._max
      ctx.drawImage(this._cell, p[0] - this._r / 2, p[1] - this._r / 2)
    }

    // colorize the heatmap, using opacity value of each pixel to get the right color from our gradient
    var colored = ctx.getImageData(0, 0, this._width, this._height)
    this._colorize(colored.data, this._grad, opacity)
    ctx.putImageData(colored, 0, 0)

    return this
  },

  _colorize: function (pixels, gradient, opacity) {
    for (var i = 0, len = pixels.length, j; i < len; i += 4) {
      j = pixels[i + 3] * 4

      pixels[i] = gradient[j]
      pixels[i + 1] = gradient[j + 1]
      pixels[i + 2] = gradient[j + 2]
      pixels[i + 3] = opacity * 256
    }
  }
}
window.simpleidw = simpleidw

L.IdwLayer = (L.Layer ? L.Layer : L.Class).extend({
  /*
  options: {
      opacity: 0.5,
      maxZoom: 18,
      cellSize: 1,
      exp: 2,
      max: 100
  },
  */
  initialize: function (latlngs, options) {
    this._latlngs = latlngs
    L.setOptions(this, options)
  },

  setLatLngs: function (latlngs) {
    this._latlngs = latlngs
    return this.redraw()
  },

  addLatLng: function (latlng) {
    this._latlngs.push(latlng)
    return this.redraw()
  },

  setOptions: function (options) {
    L.setOptions(this, options)
    if (this._idw) {
      this._updateOptions()
    }
    return this.redraw()
  },

  redraw: function () {
    if (this._idw && !this._frame && !this._map._animating) {
      this._frame = L.Util.requestAnimFrame(this._redraw, this)
    }
    return this
  },

  onAdd: function (map) {
    this._map = map

    if (!this._canvas) {
      this._initCanvas()
    }

    map._panes.overlayPane.appendChild(this._canvas)

    map.on('moveend', this._reset, this)

    if (map.options.zoomAnimation && L.Browser.any3d) {
      map.on('zoomanim', this._animateZoom, this)
    }

    this._reset()
  },

  onRemove: function (map) {
    map.getPanes().overlayPane.removeChild(this._canvas)

    map.off('moveend', this._reset, this)

    if (map.options.zoomAnimation) {
      map.off('zoomanim', this._animateZoom, this)
    }
  },

  addTo: function (map) {
    map.addLayer(this)
    return this
  },

  _initCanvas: function () {
    var canvas = this._canvas = L.DomUtil.create('canvas', 'leaflet-idwmap-layer leaflet-layer')

    var originProp = L.DomUtil.testProp(['transformOrigin', 'WebkitTransformOrigin', 'msTransformOrigin'])
    canvas.style[originProp] = '50% 50%'

    var size = this._map.getSize()
    canvas.width = size.x
    canvas.height = size.y

    var animated = this._map.options.zoomAnimation && L.Browser.any3d
    L.DomUtil.addClass(canvas, 'leaflet-zoom-' + (animated ? 'animated' : 'hide'))
    this._idw = simpleidw(canvas, this._map)
    this._updateOptions()
  },

  _updateOptions: function () {
    this._idw.defaultCellSize = this.options.cellSize || this._idw.defaultCellSize

    if (this.options.gradient) {
      this._idw.gradient(this.options.gradient)
    }
    if (this.options.max) {
      this._idw.max(this.options.max)
    }
  },

  _reset: function () {
    var topLeft = this._map.containerPointToLayerPoint([0, 0])
    L.DomUtil.setPosition(this._canvas, topLeft)

    var size = this._map.getSize()

    if (this._idw._width !== size.x) {
      this._canvas.width = this._idw._width = size.x
    }
    if (this._idw._height !== size.y) {
      this._canvas.height = this._idw._height = size.y
    }

    this._redraw()
  },

  _redraw: function () {
    if (!this._map) {
      return
    }

    let pointData = []
    _.forEach(this._latlngs, (item, index) => {
      let item2 = this._map.latLngToContainerPoint(item)
      pointData.push([item2.x, item2.y, item[2]])
    })
    this._idw.data(pointData).draw(this.options.opacity)

    this._frame = null
  },

  _animateZoom: function (e) {
    var scale = this._map.getZoomScale(e.zoom),
      offset = this._map._getCenterOffset(e.center)._multiplyBy(-scale).subtract(this._map._getMapPanePos())

    if (L.DomUtil.setTransform) {
      L.DomUtil.setTransform(this._canvas, offset, scale)

    } else {
      this._canvas.style[L.DomUtil.TRANSFORM] = L.DomUtil.getTranslateString(offset) + ' scale(' + scale + ')'
    }
  },
  setData: function (data) {
    this.setLatLngs(data)
  }
})

L.idwLayer = function (latlngs, options) {
  return new L.IdwLayer(latlngs, options)
}

export default {
  name: 'LIwdLayer',
  mixins: [LayerGroup],
  props: {
    geojson: {
      type: [Object, Array],
      custom: true,
      default: () => ({})
    },
    options: {
      type: Object,
      custom: true,
      default: () => ({})
    }
  },
  computed: {
    mergedOptions () {
      return optionsMerger({
        ...this.layerGroupOptions
      }, this);
    }
  },
  mounted() {
    this.mapObject = L.idwLayer(this.geojson, this.options)
    L.DomEvent.on(this.mapObject, this.$listeners)
    propsBinder(this, this.mapObject, this.$options.props)
    this.parentContainer = findRealParent(this.$parent, true)
    this.parentContainer.addLayer(this, !this.visible)
  },
  beforeDestroy() {
    this.parentContainer.mapObject.removeLayer(this.mapObject)
  },
  methods: {
    setGeojson(newVal) {
      // this.mapObject.clearLayers()
      this.mapObject.setData(newVal)
    },
    getGeoJSONData() {
      return this.mapObject.toGeoJSON()
    },
    getBounds() {
      return this.mapObject.getBounds()
    },
    setOptions(newVal, oldVal) {
      // this.mapObject.clearLayers()
      L.setOptions(this.mapObject, this.mergedOptions)
      this.mapObject.setData(this.geojson)
    },
    setOptionsStyle(newVal, oldVal) {
      this.mapObject.setStyle(newVal)
    }
  },
  render() {
    return null
  }
}
</script>



// WEBPACK FOOTER //
// src/components/map/LIdwLeaflet.vue